import axios from "axios";
import { withRouter } from "react-router-dom";

const http = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { Accept: "*" },
});

export default withRouter(http);
